import { useQuery } from "@tanstack/react-query";
import { listMembers } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";

export function useMembersList() {
  return useQuery({
    queryKey: queryKeys.members.list,
    queryFn: () => listMembers(),
  });
}
